import React, { Component } from "react";

export default class Icons extends Component {
  constructor(props) {
    super(props);
  }

  getIcon() {
    const { icon } = this.props;

    if (icon === 'c-width') {
      return (
        <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.769 12.712L14.282 11.251L12.769 9.79C12.6981 9.7216 12.6414 9.6399 12.602 9.5495C12.5627 9.4592 12.5415 9.362 12.5398 9.2634C12.538 9.1649 12.5557 9.067 12.5918 8.9753C12.6278 8.8836 12.6816 8.7999 12.75 8.729C12.8184 8.6581 12.9002 8.6013 12.9905 8.562C13.0809 8.5227 13.1781 8.5015 13.2766 8.4998C13.3751 8.498 13.473 8.5157 13.5647 8.5517C13.6564 8.5878 13.7401 8.6416 13.811 8.71L15.697 10.531C15.7938 10.6243 15.8708 10.7361 15.9234 10.8598C15.976 10.9835 16.0031 11.1166 16.0031 11.251C16.0031 11.3854 15.976 11.5185 15.9234 11.6422C15.8708 11.7659 15.7938 11.8777 15.697 11.971L13.811 13.791C13.6679 13.9292 13.4758 14.0049 13.2769 14.0014C13.0781 13.9979 12.8887 13.9156 12.7505 13.7725C12.6123 13.6294 12.5367 13.4373 12.5401 13.2384C12.5436 13.0395 12.6259 12.8502 12.769 12.712ZM3.23503 12.712L1.72103 11.251L3.23403 9.79C3.37724 9.6518 3.4597 9.4624 3.46327 9.2634C3.46683 9.0645 3.3912 8.8722 3.25303 8.729C3.11485 8.5858 2.92544 8.5033 2.72646 8.4998C2.52749 8.4962 2.33524 8.5718 2.19203 8.71L0.30603 10.531C0.20924 10.6243 0.13226 10.7361 0.07968 10.8598C0.0271 10.9835 0 11.1166 0 11.251C0 11.3854 0.0271 11.5185 0.07968 11.6422C0.13226 11.7659 0.20924 11.8777 0.30603 11.971L2.19203 13.791C2.33511 13.9292 2.52723 14.0049 2.72611 14.0014C2.92499 13.9979 3.11435 13.9156 3.25253 13.7725C3.3907 13.6294 3.46638 13.4373 3.46291 13.2384C3.45944 13.0395 3.37711 12.8502 3.23403 12.712H3.23503ZM6.00103 11.252C6.00103 11.4509 5.92201 11.6417 5.78136 11.7823C5.6407 11.923 5.44994 12.002 5.25103 12.002H4.75103C4.55211 12.002 4.36135 11.923 4.2207 11.7823C4.08004 11.6417 4.00103 11.4509 4.00103 11.252C4.00103 11.0531 4.08004 10.8623 4.2207 10.7217C4.36135 10.581 4.55211 10.502 4.75103 10.502H5.25103C5.44994 10.502 5.6407 10.581 5.78136 10.7217C5.92201 10.8623 6.00103 11.0531 6.00103 11.252ZM7.75103 12.002C7.55211 12.002 7.36135 11.923 7.2207 11.7823C7.08004 11.6417 7.00103 11.4509 7.00103 11.252C7.00103 11.0531 7.08004 10.8623 7.2207 10.7217C7.36135 10.581 7.55211 10.502 7.75103 10.502H8.251C8.4499 10.502 8.6407 10.581 8.7814 10.7217C8.922 10.8623 9.001 11.0531 9.001 11.252C9.001 11.4509 8.922 11.6417 8.7814 11.7823C8.6407 11.923 8.4499 12.002 8.251 12.002H7.75103ZM10.001 11.252C10.001 11.667 10.337 12.002 10.751 12.002H11.251C11.4499 12.002 11.6407 11.923 11.7814 11.7823C11.922 11.6417 12.001 11.4509 12.001 11.252C12.001 11.0531 11.922 10.8623 11.7814 10.7217C11.6407 10.581 11.4499 10.502 11.251 10.502H10.751C10.5521 10.502 10.3613 10.581 10.2207 10.7217C10.08 10.8623 10.001 11.0531 10.001 11.252ZM15.001 2C15.001 1.46957 14.7903 0.96086 14.4152 0.58579C14.0402 0.21071 13.5315 0 13.001 0H3.00103C2.47059 0 1.96189 0.21071 1.58681 0.58579C1.21174 0.96086 1.00103 1.46957 1.00103 2V6.25C1.00103 6.4489 1.08004 6.6397 1.2207 6.7803C1.36135 6.921 1.55211 7 1.75103 7C1.94994 7 2.1407 6.921 2.28136 6.7803C2.42201 6.6397 2.50103 6.4489 2.50103 6.25V2C2.50103 1.86739 2.5537 1.74021 2.64747 1.64645C2.74124 1.55268 2.86842 1.5 3.00103 1.5H13.001C13.1336 1.5 13.2608 1.55268 13.3546 1.64645C13.4483 1.74021 13.501 1.86739 13.501 2V6.25C13.501 6.4489 13.58 6.6397 13.7207 6.7803C13.8613 6.921 14.0521 7 14.251 7C14.4499 7 14.6407 6.921 14.7814 6.7803C14.922 6.6397 15.001 6.4489 15.001 6.25V2Z" fill="black" />
        </svg>
      )
    }

    if (icon === "grip") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="icon-grip"
          viewBox="0 0 448 512"
        >
          <path d="M440 192H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm0 96H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z" />
        </svg>
      );
    }

    if (icon == "spacer") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="icon-spacer"
          viewBox="0 0 448 512"
        >
          <path d="M0 76V52a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6zm166 134h276a6 6 0 0 0 6-6v-24a6 6 0 0 0-6-6H166a6 6 0 0 0-6 6v24a6 6 0 0 0 6 6zM6 466h436a6 6 0 0 0 6-6v-24a6 6 0 0 0-6-6H6a6 6 0 0 0-6 6v24a6 6 0 0 0 6 6zm160-128h276a6 6 0 0 0 6-6v-24a6 6 0 0 0-6-6H166a6 6 0 0 0-6 6v24a6 6 0 0 0 6 6zM0 351.987V160.014c0-14.27 17.283-21.346 27.313-11.313l96 95.986c6.249 6.248 6.249 16.379 0 22.627l-96 95.987C17.296 373.318 0 366.281 0 351.987zm32-153.36v114.746L89.373 256 32 198.627z" />
        </svg>
      );
    }

    if (icon === "tabs") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="26"
          viewBox="0 0 30 26"
        >
          <path
            fill="#A4A8C0"
            fill-rule="nonzero"
            d="M8.25.07a1.18 1.18 0 0 1 1.06 1.26V5h19.13a1.18 1.18 0 0 1 1.06 1.23V23.4a2.4 2.4 0 0 1-2.09 2.6H2.09a1.9 1.9 0 0 1-1.51-.8A3 3 0 0 1 0 23.4V1.33A1.18 1.18 0 0 1 1.07.07h7.18zm0 .75H1.07c-.15 0-.31.18-.31.51V23.4c-.01.484.137.957.42 1.35.209.306.55.495.92.51h25.31c.74 0 1.34-.83 1.34-1.86V6.23c0-.3-.16-.52-.31-.52H8.93a.38.38 0 0 1-.37-.37v-4c0-.3-.16-.52-.31-.52zm13.31 18.107a.38.38 0 0 1-.38.583H4.61a.38.38 0 0 1 0-.75h16.57a.38.38 0 0 1 .38.167zM4.61 15.52h20.28a.38.38 0 0 1 0 .75H4.61a.38.38 0 1 1 0-.75zm0-3.27h20.28a.38.38 0 0 1 0 .75H4.61a.38.38 0 1 1 0-.75zM18.47.263a1 1 0 0 1 .32.737v2.78a.38.38 0 0 1-.75 0V1c0-.1-.14-.2-.33-.2h-6c-.19 0-.33.11-.33.2v2.85a.38.38 0 0 1-.38.37.38.38 0 0 1-.37-.37V1a1 1 0 0 1 1.08-1h6a1 1 0 0 1 .76.263zm9.11 0A1 1 0 0 1 27.9 1v2.78a.38.38 0 1 1-.75 0V1c0-.1-.14-.2-.33-.2h-6c-.19 0-.33.11-.33.2v2.85a.38.38 0 0 1-.38.37.38.38 0 0 1-.37-.37V1a1 1 0 0 1 1.08-1h6a1 1 0 0 1 .76.263z"
          />
        </svg>
      );
    }

    if (icon == "collapse")
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="29px"
          height="27px"
          viewBox="0 0 29 27"
          version="1.1"
        >
          <g
            id="Page-1"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="collapse">
              <path
                d="M26,0 C27.3144377,0 28.38,1.0655623 28.38,2.38 L28.38,24 C28.38,25.3144377 27.3144377,26.38 26,26.38 L2.38,26.38 C1.0655623,26.38 0,25.3144377 0,24 L0,2.38 C0,1.0655623 1.0655623,0 2.38,0 L26,0 Z M27.6700001,5.66 L0.75,5.66 L0.75,24 C0.75,24.9 1.48,25.63 2.38,25.63 L26,25.63 C26.4391911,25.640781 26.8641389,25.4738206 27.1785298,25.16696 C27.4929207,24.8600994 27.6700001,24.4393234 27.6700001,24 L27.6700001,5.66 L27.6700001,5.66 Z M26,0.75 L2.38,0.75 C1.48,0.75 0.75,1.48 0.75,2.38 L0.75,4.91 L27.6700001,4.91 L27.6700001,2.38 C27.6700001,1.94067658 27.4929207,1.51990065 27.1785298,1.21304005 C26.8641389,0.906179444 26.4391911,0.739219037 26,0.75 Z"
                id="Shape"
                fill="#A4A8C0"
                fill-rule="nonzero"
              />
              <line
                x1="4.25022846"
                y1="10.7238214"
                x2="23.503335"
                y2="10.329801"
                id="Line-Copy"
                stroke="#A4A8C0"
                stroke-linecap="square"
                transform="translate(13.750228, 10.223821) rotate(1.000000) translate(-13.750228, -10.223821) "
              />
              <line
                x1="4.25022846"
                y1="14.0482177"
                x2="23.503335"
                y2="13.6541972"
                id="Line-Copy-2"
                stroke="#A4A8C0"
                stroke-linecap="square"
                transform="translate(13.750228, 13.548218) rotate(1.000000) translate(-13.750228, -13.548218) "
              />
              <line
                x1="4.25022846"
                y1="17.3726139"
                x2="23.503335"
                y2="16.9785935"
                id="Line-Copy-3"
                stroke="#A4A8C0"
                stroke-linecap="square"
                transform="translate(13.750228, 16.872614) rotate(1.000000) translate(-13.750228, -16.872614) "
              />
              <line
                x1="4.12655329"
                y1="20.6970102"
                x2="23.3796599"
                y2="20.3029898"
                id="Line-Copy-4"
                stroke="#A4A8C0"
                stroke-linecap="square"
                transform="translate(13.626553, 20.197010) rotate(1.000000) translate(-13.626553, -20.197010) "
              />
            </g>
          </g>
        </svg>
      );

    if (icon == "dashed-line")
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="2"
          viewBox="0 0 16 2"
          transform="translate(0px, 6px)"
        >
          <path
            fill="#A4A8C0"
            fill-rule="nonzero"
            d="M3 0a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2h2zm6 0a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2h2zm6 0a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2h2z"
          />
        </svg>
      );

    if (icon == "error")
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            id="Shape"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 10C0 4.47915 4.47754 0 10 0C15.5225 0 20 4.47915 20 10C20 15.5241 15.5225 20 10 20C4.47754 20 0 15.5241 0 10ZM1.93548 10C1.93548 14.4584 5.54306 18.0645 10 18.0645C14.4584 18.0645 18.0645 14.4569 18.0645 10C18.0645 5.54319 14.4553 1.93548 10 1.93548C5.54323 1.93548 1.93548 5.54456 1.93548 10ZM11.6935 13.871C11.6935 14.8048 10.9338 15.5645 10 15.5645C9.06617 15.5645 8.30645 14.8048 8.30645 13.871C8.30645 12.9371 9.06617 12.1774 10 12.1774C10.9338 12.1774 11.6935 12.9371 11.6935 13.871ZM8.68669 10.8306L8.4125 5.34673C8.39867 5.07036 8.61903 4.83871 8.89577 4.83871H11.1042C11.381 4.83871 11.6013 5.07036 11.5875 5.34673L11.3133 10.8306C11.3004 11.0881 11.0879 11.2903 10.83 11.2903H9.16996C8.91214 11.2903 8.69956 11.0881 8.68669 10.8306Z"
            fill="white"
          />
        </svg>
      );

    if (icon == "transparency")
      return (
        <svg
          width="15px"
          height="15px"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity=".25"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0H3V3H0V0ZM6 3H3V6H0V9H3V12H0V15H3V12H6V15H9V12H12V15H15V12H12V9H15V6H12V3H15V0H12V3H9V0H6V3ZM6 6V3H9V6H6ZM6 9H3V6H6V9ZM9 9V6H12V9H9ZM9 9H6V12H9V9Z"
            fill="currentColor"
          />
        </svg>
      );

    if (icon == "warning")
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            id="Warning Triangel"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.4437 0.936914C10.8036 -0.311172 9.19758 -0.313437 8.55636 0.936914L0.224901 17.188C-0.414752 18.4354 0.386047 20 1.66855 20H18.3313C19.6113 20 20.4158 18.4378 19.7749 17.188L11.4437 0.936914ZM8.86581 12.3713L8.63706 7.99629C8.62299 7.72703 8.81327 7.5 9.05296 7.5H10.947C11.1867 7.5 11.377 7.72703 11.3629 7.99629L11.1341 12.3713C11.1212 12.619 10.9388 12.8125 10.7182 12.8125H9.28174C9.06115 12.8125 8.87876 12.6191 8.86581 12.3713ZM10 16.6406C10.8054 16.6406 11.4583 15.9061 11.4583 15C11.4583 14.0939 10.8054 13.3594 10 13.3594C9.19459 13.3594 8.54167 14.0939 8.54167 15C8.54167 15.9061 9.19459 16.6406 10 16.6406ZM9.81956 2.22688L1.84692 17.7735C1.76681 17.9298 1.86705 18.125 2.02737 18.125H17.9726C18.133 18.125 18.2332 17.9297 18.1531 17.7735L10.1805 2.22688C10.1003 2.07055 9.89973 2.07055 9.81956 2.22688Z"
            fill="white"
          />
        </svg>
      );

    if (icon == "success")
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="check-circle">
            <path
              id="Shape"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10 0C4.47714 0 0 4.47714 0 10C0 15.5229 4.47714 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47714 15.5229 0 10 0ZM10 1.93548C14.4569 1.93548 18.0645 5.54238 18.0645 10C18.0645 14.4569 14.4576 18.0645 10 18.0645C5.54306 18.0645 1.93548 14.4576 1.93548 10C1.93548 5.54306 5.54238 1.93548 10 1.93548ZM14.7447 6.27214L15.6534 7.18819C15.8416 7.3779 15.8404 7.68427 15.6507 7.8725L8.69145 14.7759C8.50173 14.9641 8.19536 14.9629 8.00718 14.7731L4.34665 11.083C4.15843 10.8932 4.15968 10.5869 4.34939 10.3987L5.26548 9.48996C5.4552 9.30177 5.76157 9.30302 5.94976 9.49274L8.36073 11.9233L14.0604 6.2694C14.2501 6.08117 14.5565 6.08242 14.7447 6.27214Z"
              fill="white"
            />
          </g>
        </svg>
      );

    if (icon == "angle-right")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
          <path d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z" />
        </svg>
      );

    if (icon == "left-angle")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
          <path d="M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z" />
        </svg>
      );
    if (icon == "underline")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path d="M416 448H32c-17.69 0-32 14.31-32 32s14.31 32 32 32h384c17.69 0 32-14.31 32-32S433.7 448 416 448zM48 64.01H64v160c0 88.22 71.78 159.1 160 159.1s160-71.78 160-159.1v-160h16c17.69 0 32-14.32 32-32s-14.31-31.1-32-31.1l-96-.0049c-17.69 0-32 14.32-32 32s14.31 32 32 32H320v160c0 52.94-43.06 95.1-96 95.1S128 276.1 128 224v-160h16c17.69 0 32-14.31 32-32s-14.31-32-32-32l-96 .0049c-17.69 0-32 14.31-32 31.1S30.31 64.01 48 64.01z" />
        </svg>
      );

    if (icon == "italic")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
          <path d="M384 64.01c0 17.69-14.31 32-32 32h-58.67l-133.3 320H224c17.69 0 32 14.31 32 32s-14.31 32-32 32H32c-17.69 0-32-14.31-32-32s14.31-32 32-32h58.67l133.3-320H160c-17.69 0-32-14.31-32-32s14.31-32 32-32h192C369.7 32.01 384 46.33 384 64.01z" />
        </svg>
      );

    if (icon == "bold")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
          <path d="M321.1 242.4C340.1 220.1 352 191.6 352 160c0-70.59-57.42-128-128-128L32 32.01c-17.67 0-32 14.31-32 32s14.33 32 32 32h16v320H32c-17.67 0-32 14.31-32 32s14.33 32 32 32h224c70.58 0 128-57.41 128-128C384 305.3 358.6 264.8 321.1 242.4zM112 96.01H224c35.3 0 64 28.72 64 64s-28.7 64-64 64H112V96.01zM256 416H112v-128H256c35.3 0 64 28.71 64 63.1S291.3 416 256 416z" />
        </svg>
      );

    if (icon == "reset")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M449.9 39.96l-48.5 48.53C362.5 53.19 311.4 32 256 32C161.5 32 78.59 92.34 49.58 182.2c-5.438 16.81 3.797 34.88 20.61 40.28c16.97 5.5 34.86-3.812 40.3-20.59C130.9 138.5 189.4 96 256 96c37.96 0 73 14.18 100.2 37.8L311.1 178C295.1 194.8 306.8 223.4 330.4 224h146.9C487.7 223.7 496 215.3 496 204.9V59.04C496 34.99 466.9 22.95 449.9 39.96zM441.8 289.6c-16.94-5.438-34.88 3.812-40.3 20.59C381.1 373.5 322.6 416 256 416c-37.96 0-73-14.18-100.2-37.8L200 334C216.9 317.2 205.2 288.6 181.6 288H34.66C24.32 288.3 16 296.7 16 307.1v145.9c0 24.04 29.07 36.08 46.07 19.07l48.5-48.53C149.5 458.8 200.6 480 255.1 480c94.45 0 177.4-60.34 206.4-150.2C467.9 313 458.6 294.1 441.8 289.6z" />
        </svg>
      );

    if (icon == "theme")
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="icon-brush"
          width="12"
          height="12"
          viewBox="0 0 12 12"
        >
          <path
            strokeWidth={0}
            d="M11.7666 4.14271L11.1699 3.54602C10.969 3.34512 10.6829 3.27156 10.4196 3.33555C10.4836 3.07211 10.4099 2.78607 10.2091 2.58522L8.91472 1.29085C8.79506 1.17119 8.64407 1.09594 8.48489 1.06906C8.45799 0.909746 8.38263 0.758757 8.2631 0.639234L7.85679 0.232923C7.54623 -0.0776412 7.04271 -0.0776412 6.73215 0.232923L2.66305 4.30205C2.35249 4.61258 2.35249 5.1161 2.66305 5.42666L3.5297 6.29331C3.61094 6.37453 3.65033 6.48666 3.6378 6.6009C3.62526 6.71515 3.56227 6.8162 3.46499 6.8782C0.881865 8.52478 0.639266 8.76738 0.535647 8.871C-0.179187 9.58583 -0.179213 10.749 0.535647 11.4638C1.25048 12.1787 2.41361 12.1787 3.12848 11.4638C3.23209 11.3602 3.47472 11.1176 5.12127 8.53446C5.18296 8.43768 5.28393 8.37499 5.39831 8.36242C5.51314 8.3498 5.62535 8.38893 5.70619 8.46978L6.57284 9.33642C6.8834 9.64699 7.38692 9.64696 7.69748 9.33642L11.7666 5.26735C12.0771 4.95679 12.0771 4.45327 11.7666 4.14271ZM7.13517 8.77417L6.26853 7.90752C6.01726 7.65626 5.66479 7.53321 5.31157 7.57199C4.95836 7.61077 4.64172 7.80743 4.45073 8.10707C3.72092 9.252 2.80158 10.6662 2.56619 10.9015C2.16076 11.307 1.50342 11.307 1.09798 10.9015C0.692547 10.4961 0.692547 9.8388 1.09798 9.43333C1.33334 9.19797 2.74753 8.27863 3.89245 7.54879C4.19226 7.3577 4.38947 7.04112 4.42826 6.68772C4.46704 6.33432 4.34338 5.9824 4.09201 5.731L3.22536 4.86436L3.85733 4.23238L7.76712 8.14217L7.13517 8.77417ZM8.32996 7.57936L4.42014 3.66957L7.29448 0.795232L7.70079 1.20152L7.24701 2.20817C7.23155 2.24248 7.23895 2.28274 7.26548 2.30927C7.26575 2.30954 7.26604 2.3098 7.26631 2.31007C7.29353 2.3366 7.33443 2.34328 7.36868 2.3268L8.35241 1.85316L9.64678 3.14753L7.91606 5.72686C7.89197 5.76276 7.89666 5.81066 7.92722 5.84119C7.92728 5.84124 7.92736 5.84132 7.92741 5.84138C7.95811 5.87191 8.00619 5.87637 8.04198 5.85203L10.6076 4.1083L11.2043 4.70499L8.32996 7.57936Z"
          />
          <path d="M1.95754 10.5108C2.21617 10.5108 2.42583 10.3011 2.42583 10.0425C2.42583 9.78386 2.21617 9.5742 1.95754 9.5742C1.69892 9.5742 1.48926 9.78386 1.48926 10.0425C1.48926 10.3011 1.69892 10.5108 1.95754 10.5108Z" />
        </svg>
      );

    if (icon === "edit")
      return (
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="edit"
          class="svg-inline--fa fa-edit fa-w-18"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
        >
          <path d="M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"></path>
        </svg>
      );

    if (icon === "menu")
      return (
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="ellipsis-h"
          class="svg-inline--fa fa-ellipsis-h fa-w-16"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
        >
          <path d="M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"></path>
        </svg>
      );

    if (icon === "elements")
      return (
        <svg
          data-v-919ca0b0=""
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="21"
        >
          <g data-v-919ca0b0="" fill="none">
            <path
              data-v-919ca0b0=""
              stroke="#CCCEDC"
              d="M8.74 12.313H4.594a4.094 4.094 0 100 8.187H8.74a4.094 4.094 0 000-8.188zm13.96 0h-6.733a.8.8 0 00-.8.8V19.7a.8.8 0 00.8.8H22.7a.8.8 0 00.8-.8v-6.587a.8.8 0 00-.8-.8zM22.7.5H1.3a.8.8 0 00-.8.8v6.587a.8.8 0 00.8.8h21.4a.8.8 0 00.8-.8V1.3a.8.8 0 00-.8-.8z"
            ></path>
            <path
              data-v-919ca0b0=""
              fill="#CCCEDC"
              d="M20.847 15.281a.65.65 0 11.937.902l-1.946 2.022a.65.65 0 01-.927.01l-1.367-1.346a.65.65 0 01.83-.994l.082.068.901.887zM6 3.944h12a.65.65 0 01.096 1.293L18 5.244H6a.65.65 0 01-.096-1.293L6 3.944h12z"
            ></path>
            <ellipse
              data-v-919ca0b0=""
              cx="4.667"
              cy="16.406"
              fill="#CCCEDC"
              rx="2"
              ry="1.969"
            ></ellipse>
          </g>
        </svg>
      );

    if (icon === "pages")
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="icon-layers"
          viewBox="0 0 512 512"
        >
          <path d="M512 256.01c0-9.98-5.81-18.94-14.77-22.81l-99.74-43.27 99.7-43.26c9-3.89 14.81-12.84 14.81-22.81s-5.81-18.92-14.77-22.79L271.94 3.33c-10.1-4.44-21.71-4.45-31.87-.02L14.81 101.06C5.81 104.95 0 113.9 0 123.87s5.81 18.92 14.77 22.79l99.73 43.28-99.7 43.26C5.81 237.08 0 246.03 0 256.01c0 9.97 5.81 18.92 14.77 22.79l99.72 43.26-99.69 43.25C5.81 369.21 0 378.16 0 388.14c0 9.97 5.81 18.92 14.77 22.79l225.32 97.76a40.066 40.066 0 0 0 15.9 3.31c5.42 0 10.84-1.1 15.9-3.31l225.29-97.74c9-3.89 14.81-12.84 14.81-22.81 0-9.98-5.81-18.94-14.77-22.81l-99.72-43.26 99.69-43.25c9-3.89 14.81-12.84 14.81-22.81zM45.23 123.87l208.03-90.26.03-.02c1.74-.71 3.65-.76 5.45.02l208.03 90.26-208.03 90.27c-1.81.77-3.74.77-5.48 0L45.23 123.87zm421.54 264.27L258.74 478.4c-1.81.77-3.74.77-5.48 0L45.23 388.13l110.76-48.06 84.11 36.49a40.066 40.066 0 0 0 15.9 3.31c5.42 0 10.84-1.1 15.9-3.31l84.11-36.49 110.76 48.07zm-208.03-41.87c-1.81.77-3.74.77-5.48 0L45.23 256 156 207.94l84.1 36.5a40.066 40.066 0 0 0 15.9 3.31c5.42 0 10.84-1.1 15.9-3.31l84.1-36.49 110.77 48.07-208.03 90.25z" />
        </svg>
        // <svg
        //   data-v-919ca0b0=""
        //   xmlns="http://www.w3.org/2000/svg"
        //   width="21"
        //   height="20"
        // >
        //   <path
        //     data-v-919ca0b0=""
        //     fill="#A4A8C0"
        //     d="M18.76 4a2 2 0 012 2v12a2 2 0 01-2 2H6.12a2 2 0 01-2-2V6a2 2 0 012-2h12.64zm0 1H6.12a1 1 0 00-1 1v12a1 1 0 001 1h12.64a1 1 0 001-1V6a1 1 0 00-1-1zM16.272.5a1.5 1.5 0 011.5 1.5v1.492h-1V2a.5.5 0 00-.5-.5H3A1.5 1.5 0 001.5 3v12.756a.5.5 0 00.5.5h1.3v1H2a1.5 1.5 0 01-1.5-1.5V3A2.5 2.5 0 013 .5h13.272z"
        //   ></path>
        // </svg>
      );

    if (icon === "blocks")
      return (
        <svg
          data-v-919ca0b0=""
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
        >
          <path
            data-v-919ca0b0=""
            fill="#A4A8C0"
            d="M9.961 12.463c.64 0 1.157.517 1.157 1.156v8.79a1.157 1.157 0 01-1.157 1.172H1.157A1.157 1.157 0 010 22.424v-8.805c0-.639.518-1.156 1.157-1.156H9.96zm12.882 0c.639 0 1.157.517 1.157 1.156v8.79a1.157 1.157 0 01-1.157 1.172h-8.79a1.157 1.157 0 01-1.157-1.157v-8.805c0-.639.518-1.156 1.157-1.156h8.79zM1.157 13.547l-.073 8.862 8.863.073c.04 0 .072-.033.072-.073v-8.79l-8.862-.072zm12.896 0l-.072 8.862 8.862.073c.04 0 .072-.033.072-.073v-8.79l-8.862-.072zM9.96 0c.64 0 1.157.518 1.157 1.157v8.79a1.157 1.157 0 01-1.157 1.128H1.157A1.157 1.157 0 010 9.918V1.157C0 .517.518 0 1.157 0H9.96zm12.882 0C23.482 0 24 .518 24 1.157v8.79a1.157 1.157 0 01-1.157 1.128h-8.79a1.157 1.157 0 01-1.157-1.157V1.157c0-.64.518-1.157 1.157-1.157h8.79zM1.157 1.084l-.073 8.863 8.863.072c.04 0 .072-.032.072-.072v-8.79l-8.862-.073zm12.896 0l-.072 8.863 8.862.072c.04 0 .072-.032.072-.072v-8.79l-8.862-.073z"
          ></path>
        </svg>
      );

    if (icon === "dropdown")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
          <path d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"></path>
        </svg>
      );

    if (icon === "dropdown-thin")
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 512.011 512.011"
        >
          <g>
            <g>
              <path d="M505.755,123.592c-8.341-8.341-21.824-8.341-30.165,0L256.005,343.176L36.421,123.592c-8.341-8.341-21.824-8.341-30.165,0 s-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251c5.462,0,10.923-2.091,15.083-6.251l234.667-234.667 C514.096,145.416,514.096,131.933,505.755,123.592z" />
            </g>
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
      );

    if (icon === "dropup")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
          <path d="M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"></path>
        </svg>
      );

    if (icon === "xl-device")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17">
          <path d="M14.607 0a2.8 2.8 0 012.8 2.8v6.922a2.8 2.8 0 01-2.8 2.8L9.4 12.52V15h3.351a.7.7 0 010 1.4H4.7a.7.7 0 010-1.4H8v-2.479H2.8a2.8 2.8 0 01-2.8-2.8V2.8A2.8 2.8 0 012.8 0h11.807zm0 1.4H2.8a1.4 1.4 0 00-1.4 1.4v6.922a1.4 1.4 0 001.4 1.4h11.807a1.4 1.4 0 001.4-1.4V2.8a1.4 1.4 0 00-1.4-1.4z"></path>
        </svg>
      );

    if (icon === "lg-device")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16">
          <path d="M16.3 14a.7.7 0 010 1.4H1.7a.7.7 0 010-1.4h14.6zM14.607 0a2.8 2.8 0 012.8 2.8v6.922a2.8 2.8 0 01-2.8 2.8H2.8a2.8 2.8 0 01-2.8-2.8V2.8A2.8 2.8 0 012.8 0h11.807zm0 1.4H2.8a1.4 1.4 0 00-1.4 1.4v6.922a1.4 1.4 0 001.4 1.4h11.807a1.4 1.4 0 001.4-1.4V2.8a1.4 1.4 0 00-1.4-1.4z"></path>
        </svg>
      );

    if (icon === "md-device")
      return (
        <svg width="21" height="18" xmlns="http://www.w3.org/2000/svg">
          <g fill="none">
            <path
              d="M3.675 0h13.65C19.355 0 21 1.41 21 3.15v11.7c0 1.74-1.645 3.15-3.675 3.15H3.675C1.645 18 0 16.59 0 14.85V3.15C0 1.41 1.645 0 3.675 0zm0 1.575c-1.015 0-1.837.705-1.837 1.575v11.7c0 .87.822 1.575 1.837 1.575h13.65c1.015 0 1.838-.705 1.838-1.575V3.15c0-.87-.823-1.575-1.838-1.575H3.675z"
              fill="currentColor"
            ></path>
            <path
              stroke="currentColor"
              strokeLinecap="square"
              d="M17 11V8"
            ></path>
          </g>
        </svg>
      );

    if (icon === "sm-device")
      return (
        <svg width="15" height="18" xmlns="http://www.w3.org/2000/svg">
          <g fill="none">
            <path
              d="M2.625 0h9.75C13.825 0 15 1.41 15 3.15v11.7c0 1.74-1.175 3.15-2.625 3.15h-9.75C1.175 18 0 16.59 0 14.85V3.15C0 1.41 1.175 0 2.625 0zm0 1.575c-.725 0-1.313.705-1.313 1.575v11.7c0 .87.588 1.575 1.313 1.575h9.75c.725 0 1.313-.705 1.313-1.575V3.15c0-.87-.588-1.575-1.313-1.575h-9.75z"
              fill="currentColor"
            ></path>
            <path
              stroke="currentColor"
              strokeLinecap="square"
              d="M6 15h3"
            ></path>
          </g>
        </svg>
      );

    if (icon === "xs-device")
      return (
        <svg width="10" height="16" xmlns="http://www.w3.org/2000/svg">
          <g fill="none">
            <path
              d="M7.2 0A2.8 2.8 0 0110 2.8v10.4A2.8 2.8 0 017.2 16H2.8A2.8 2.8 0 010 13.2V2.8A2.8 2.8 0 012.8 0h4.4zm0 1.4H2.8a1.4 1.4 0 00-1.4 1.4v10.4a1.4 1.4 0 001.4 1.4h4.4a1.4 1.4 0 001.4-1.4V2.8a1.4 1.4 0 00-1.4-1.4z"
              fill="currentColor"
            ></path>
            <path
              stroke="currentColor"
              strokeLinecap="square"
              d="M4.5 12.5h1"
            ></path>
          </g>
        </svg>
      );

    if (icon === "right-bars")
      return (
        <svg
          data-v-81843f70=""
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="bars"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
          data-fa-i2svg=""
        >
          <path
            fill="currentColor"
            d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
          ></path>
        </svg>
      );

    if (icon === "move")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16">
          <path
            fill="#FFF"
            d="M1.333 13.333a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667zm5.334 0a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667zM1.333 6.667a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666zm5.334 0a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666zM1.333 0a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667zm5.334 0a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667z"
          ></path>
        </svg>
      );

    if (icon === "dots")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path d="M120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200C94.93 200 120 225.1 120 256zM280 256C280 286.9 254.9 312 224 312C193.1 312 168 286.9 168 256C168 225.1 193.1 200 224 200C254.9 200 280 225.1 280 256zM328 256C328 225.1 353.1 200 384 200C414.9 200 440 225.1 440 256C440 286.9 414.9 312 384 312C353.1 312 328 286.9 328 256z" />
        </svg>
      );

    if (icon === "dots-black")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="4">
          <path
            fill="#000"
            d="M2 0a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4z"
          ></path>
        </svg>
      );

    if (icon === "time")
      return (
        <svg
          data-v-919ca0b0=""
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 12 12"
        >
          <path
            data-v-919ca0b0=""
            fill="#8689A4"
            d="M7.426 5.971l4.278-4.258a1 1 0 000-1.419 1.012 1.012 0 00-1.426 0L5.999 4.552 1.721.294a1.012 1.012 0 00-1.426 0 1 1 0 000 1.42L4.573 5.97.295 10.23a1 1 0 000 1.419 1.012 1.012 0 001.426 0L6 7.39l4.279 4.258a1.012 1.012 0 001.426 0 1 1 0 000-1.42L7.426 5.972z"
          ></path>
        </svg>
      );

    if (icon === "plus")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
          <path
            // fill="#FFF"
            d="M8 0a.94.94 0 01.941.941v6.117h6.118a.941.941 0 010 1.883H8.94v6.118a.941.941 0 01-1.882 0V8.94H.941a.941.941 0 010-1.882l6.117-.001V.941A.942.942 0 018 0z"
          ></path>
        </svg>
      );
    if (icon === "plus-menu")
      return (
        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
          <rect x="11" y="0" width="1.6" height="24" rx=".2" fill="#A4A8C0" />
          <rect
            x="20"
            y="20"
            width="1.6"
            height="200"
            rx=".8"
            transform="rotate(90 28 19.2)"
            fill="#A4A8C0"
          />
        </svg>
      );

    if (icon === "minus")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <g>
            <g>
              <path d="M492,236H20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h472c11.046,0,20-8.954,20-20S503.046,236,492,236z" />
            </g>
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
      );

    if (icon === "check")
      return (
        <svg
          height="16"
          viewBox="0 0 515.556 515.556"
          width="16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m0 274.226 176.549 176.886 339.007-338.672-48.67-47.997-290.337 290-128.553-128.552z" />
        </svg>
      );

    if (icon === "asterisk")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 227.214 227.214">
          <path d="M209.255,160.178l-80.648-46.563l80.637-46.556c3.587-2.071,4.816-6.658,2.745-10.245 c-2.071-3.587-6.658-4.817-10.245-2.745l-80.643,46.559V7.5c0-4.142-3.358-7.5-7.5-7.5c-4.142,0-7.5,3.358-7.5,7.5v93.121 L25.47,54.069c-3.587-2.073-8.174-0.842-10.245,2.745c-2.071,3.587-0.842,8.174,2.745,10.245l80.637,46.556l-80.648,46.563 c-3.587,2.071-4.816,6.658-2.745,10.245c1.389,2.406,3.91,3.751,6.502,3.751c1.273,0,2.562-0.324,3.743-1.006l80.643-46.559v93.105 c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5v-93.112l80.654,46.566c1.181,0.682,2.471,1.006,3.743,1.006 c2.592,0,5.113-1.346,6.502-3.751C214.072,166.835,212.843,162.249,209.255,160.178z" />
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
      );

    if (icon === "close-circle")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <g transform="translate(1 1)">
            <g>
              <g>
                <path d="M436.016,73.984c-99.979-99.979-262.075-99.979-362.033,0.002c-99.978,99.978-99.978,262.073,0.004,362.031 c99.954,99.978,262.05,99.978,362.029-0.002C535.995,336.059,535.995,173.964,436.016,73.984z M405.848,405.844 c-83.318,83.318-218.396,83.318-301.691,0.004c-83.318-83.299-83.318-218.377-0.002-301.693 c83.297-83.317,218.375-83.317,301.691,0S489.162,322.549,405.848,405.844z" />
                <path d="M360.592,149.408c-8.331-8.331-21.839-8.331-30.17,0l-75.425,75.425l-75.425-75.425c-8.331-8.331-21.839-8.331-30.17,0 s-8.331,21.839,0,30.17l75.425,75.425L149.43,330.4c-8.331,8.331-8.331,21.839,0,30.17c8.331,8.331,21.839,8.331,30.17,0 l75.397-75.397l75.419,75.419c8.331,8.331,21.839,8.331,30.17,0c8.331-8.331,8.331-21.839,0-30.17l-75.419-75.419l75.425-75.425 C368.923,171.247,368.923,157.74,360.592,149.408z" />
              </g>
            </g>
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
      );

    if (icon === "check-circle")
      return (
        <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
          <path d="m369.164062 174.769531c7.8125 7.8125 7.8125 20.476563 0 28.285157l-134.171874 134.175781c-7.8125 7.808593-20.472657 7.808593-28.285157 0l-63.871093-63.875c-7.8125-7.808594-7.8125-20.472657 0-28.28125 7.808593-7.8125 20.472656-7.8125 28.28125 0l49.730468 49.730469 120.03125-120.035157c7.8125-7.808593 20.476563-7.808593 28.285156 0zm142.835938 81.230469c0 141.503906-114.515625 256-256 256-141.503906 0-256-114.515625-256-256 0-141.503906 114.515625-256 256-256 141.503906 0 256 114.515625 256 256zm-40 0c0-119.394531-96.621094-216-216-216-119.394531 0-216 96.621094-216 216 0 119.394531 96.621094 216 216 216 119.394531 0 216-96.621094 216-216zm0 0" />
        </svg>
      );

    if (icon === "eye")
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 511.999 511.999"
        >
          <g>
            <g>
              <path d="M508.745,246.041c-4.574-6.257-113.557-153.206-252.748-153.206S7.818,239.784,3.249,246.035 c-4.332,5.936-4.332,13.987,0,19.923c4.569,6.257,113.557,153.206,252.748,153.206s248.174-146.95,252.748-153.201 C513.083,260.028,513.083,251.971,508.745,246.041z M255.997,385.406c-102.529,0-191.33-97.533-217.617-129.418 c26.253-31.913,114.868-129.395,217.617-129.395c102.524,0,191.319,97.516,217.617,129.418 C447.361,287.923,358.746,385.406,255.997,385.406z" />
            </g>
          </g>
          <g>
            <g>
              <path d="M255.997,154.725c-55.842,0-101.275,45.433-101.275,101.275s45.433,101.275,101.275,101.275 s101.275-45.433,101.275-101.275S311.839,154.725,255.997,154.725z M255.997,323.516c-37.23,0-67.516-30.287-67.516-67.516 s30.287-67.516,67.516-67.516s67.516,30.287,67.516,67.516S293.227,323.516,255.997,323.516z" />
            </g>
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
      );

    if (icon === "noeye")
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 477.871 477.871"
        >
          <g>
            <g>
              <path d="M474.609,228.901c-29.006-38.002-63.843-71.175-103.219-98.287l67.345-67.345c6.78-6.548,6.968-17.352,0.42-24.132 c-6.548-6.78-17.352-6.968-24.132-0.42c-0.142,0.137-0.282,0.277-0.42,0.42l-73.574,73.506 c-31.317-17.236-66.353-26.607-102.093-27.307C109.229,85.336,7.529,223.03,3.262,228.9c-4.349,5.983-4.349,14.087,0,20.07 c29.006,38.002,63.843,71.175,103.219,98.287l-67.345,67.345c-6.78,6.548-6.968,17.352-0.42,24.132 c6.548,6.78,17.352,6.968,24.132,0.42c0.142-0.137,0.282-0.277,0.42-0.42l73.574-73.506 c31.317,17.236,66.353,26.607,102.093,27.307c129.707,0,231.407-137.694,235.674-143.565 C478.959,242.988,478.959,234.884,474.609,228.901z M131.296,322.494c-34.767-23.156-65.931-51.311-92.484-83.558 c25.122-30.43,106.598-119.467,200.124-119.467c26.609,0.538,52.77,6.949,76.612,18.773L285.92,167.87 c-39.2-26.025-92.076-15.345-118.101,23.855c-18.958,28.555-18.958,65.691,0,94.246L131.296,322.494z M285.016,217.005 c3.34,6.83,5.091,14.328,5.12,21.931c0,28.277-22.923,51.2-51.2,51.2c-7.603-0.029-15.101-1.78-21.931-5.12L285.016,217.005z  M192.856,260.866c-3.34-6.83-5.091-14.328-5.12-21.931c0-28.277,22.923-51.2,51.2-51.2c7.603,0.029,15.101,1.78,21.931,5.12 L192.856,260.866z M238.936,358.402c-26.609-0.538-52.769-6.949-76.612-18.773l29.628-29.628 c39.2,26.025,92.076,15.345,118.101-23.855c18.958-28.555,18.958-65.691,0-94.246l36.523-36.523 c34.767,23.156,65.931,51.312,92.484,83.558C413.937,269.366,332.461,358.402,238.936,358.402z" />
            </g>
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
      );

    if (icon === "dot")
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 29.107 29.107"
        >
          <g>
            <g>
              <g>
                <path d="M14.554,0C6.561,0,0,6.562,0,14.552c0,7.996,6.561,14.555,14.554,14.555c7.996,0,14.553-6.559,14.553-14.555 C29.106,6.562,22.55,0,14.554,0z" />
              </g>
            </g>
            <g></g>
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
      );

    if (icon === "picture")
      return (
        <svg xmlns="http://www.w3.org/2000/svg">
          <path
            fill="#A4A8C0"
            d="M17.562.91a2.63 2.63 0 012.62 2.63v14.75a2.63 2.63 0 01-2.62 2.62H2.812a2.63 2.63 0 01-2.63-2.62V3.54A2.63 2.63 0 012.812.91h14.75zM7.252 12.54a.49.49 0 00-.4.21l-5.057 7.12c.293.19.642.3 1.017.3h10.35l-5.52-7.43a.49.49 0 00-.3-.191l-.09-.01zm6.04-2.51a.27.27 0 00-.22.12l-2.932 4.73 3.929 5.29h3.493a1.88 1.88 0 001.466-.704l-5.516-9.307a.25.25 0 00-.22-.13zm4.27-8.37H2.812a1.88 1.88 0 00-1.88 1.88v14.75c0 .39.119.752.323 1.053l4.977-7.014a1.23 1.23 0 011-.52c.398-.02.777.17 1 .5l1.427 1.923 2.773-4.473a1 1 0 01.73-.472l.13-.008a1 1 0 01.86.49l5.257 8.87c.021-.11.032-.224.033-.34V3.54a1.88 1.88 0 00-1.88-1.88zM7.242 3.91a2.94 2.94 0 110 5.88 2.94 2.94 0 010-5.88zm0 .75v.01a2.19 2.19 0 102.19 2.18c0-1.21-.98-2.19-2.19-2.19z"
          ></path>
        </svg>
      );

    if (icon === "trash")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
          <path
            fill="#A4A8C0"
            d="M3.438 14.4h8.126c-.002 0-.002-8.638-.002-11.2H3.438v11.2zm9.75 0c0 .884-.73 1.6-1.624 1.6H3.436a1.61 1.61 0 01-1.623-1.6V3.2A.805.805 0 011 2.4c0-.442.361-.8.813-.8h4.062C5.875.716 6.603 0 7.5 0s1.625.716 1.625 1.6h4.062c.449 0 .813.355.813.8 0 .442-.36.8-.813.8v11.2zM8.311 5.598c0-.44.361-.798.813-.798.449 0 .813.357.813.798v6.404c0 .44-.361.798-.813.798a.805.805 0 01-.813-.798V5.598zm-3.25 0c0-.44.361-.798.813-.798.449 0 .813.357.813.798v6.404c0 .44-.361.798-.813.798a.805.805 0 01-.813-.798V5.598z"
          ></path>
        </svg>
      );

    if (icon === "dashed")
      return (
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
        >
          <g>
            <g>
              <path fill="#8688A5" d="M-0.8-0.8h5v5h-5V-0.8z" />
              <path
                fill="#CCCEDC"
                d="M-0.8,4.1h5v5h-5V4.1z M-0.8,14.1h5v5h-5V14.1z"
              />
              <path
                fill="#8688A5"
                d="M-0.8,19h5v5h-5V19z M-0.8,9.1h5v5h-5V9.1z M9.1-0.8h5v5h-5V-0.8z"
              />
              <path
                fill="#CCCEDC"
                d="M9.1,4.1h5v5h-5V4.1z M9.1,14.1h5v5h-5V14.1z"
              />
              <path
                fill="#8688A5"
                d="M9.1,19h5v5h-5V19z M9.1,9.1h5v5h-5V9.1z M19-0.8h5v5h-5V-0.8z"
              />
              <path
                fill="#CCCEDC"
                d="M19,4.1h5v5h-5V4.1z M19,14.1h5v5h-5V14.1z"
              />
              <path fill="#8688A5" d="M19,19h5v5h-5V19z M19,9.1h5v5h-5V9.1z" />
              <g>
                <path
                  fill="#CCCEDC"
                  d="M4.1-0.8h5v5h-5V-0.8z M4.1,19h5v5h-5V19z M4.1,9.1h5v5h-5V9.1z"
                />
                <path
                  fill="#8688A5"
                  d="M4.1,4.1h5v5h-5V4.1z M4.1,14.1h5v5h-5V14.1z"
                />
              </g>
              <g>
                <path
                  fill="#CCCEDC"
                  d="M14.1-0.8h5v5h-5V-0.8z M14.1,19h5v5h-5V19z M14.1,9.1h5v5h-5V9.1z"
                />
                <path
                  fill="#8688A5"
                  d="M14.1,4.1h5v5h-5V4.1z M14.1,14.1h5v5h-5V14.1z"
                />
              </g>
            </g>
          </g>
        </svg>
      );

    if (icon === "align-top-left")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13">
          <path d="M.5 13a.5.5 0 110-1H12V.5a.5.5 0 111 0v12a.5.5 0 01-.41.492L12.5 13H.5z"></path>
        </svg>
      );

    if (icon === "align-top-center")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12">
          <path d="M6.5 12a.5.5 0 00.5-.5V.98L6.998.96h5.522a.48.48 0 100-.96H.48a.48.48 0 100 .96H6a.51.51 0 000 .02V11.5a.5.5 0 00.5.5z"></path>
        </svg>
      );

    if (icon === "align-top-right")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13">
          <path d="M12.5 13a.5.5 0 000-1H1V.5a.5.5 0 00-1 0v12a.5.5 0 00.41.492L.5 13h12z"></path>
        </svg>
      );

    if (icon === "align-middle-left")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14">
          <path d="M12.5 7.25a.5.5 0 01-.5.5H1v5.5a.5.5 0 11-1 0v-12a.5.5 0 111 0v5.5h11a.5.5 0 01.5.5z"></path>
        </svg>
      );

    if (icon === "align-middle-center")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
          <path d="M6 0h4a6 6 0 016 6v3.772a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6zm0 1a5 5 0 00-5 5v3.772a5 5 0 005 5h4a5 5 0 005-5V6a5 5 0 00-5-5H6z"></path>
        </svg>
      );

    if (icon === "align-middle-right")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14">
          <path d="M0 7a.5.5 0 00.5.5h10.52l.02-.002v5.522a.48.48 0 10.96 0V.98a.48.48 0 10-.96 0V6.5a.51.51 0 00-.02 0H.5A.5.5 0 000 7z"></path>
        </svg>
      );

    if (icon === "align-bottom-left")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13">
          <path d="M.5 0a.5.5 0 100 1H12v11.5a.5.5 0 101 0V.5a.5.5 0 00-.41-.492L12.5 0H.5z"></path>
        </svg>
      );

    if (icon === "align-bottom-center")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12">
          <path d="M6.5 0a.5.5 0 01.5.5v10.52l-.002.02h5.522a.48.48 0 110 .96H.48a.48.48 0 110-.96H6a.51.51 0 010-.02V.5a.5.5 0 01.5-.5z"></path>
        </svg>
      );

    if (icon === "align-bottom-right")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13">
          <path d="M12.5 0a.5.5 0 010 1H1v11.5a.5.5 0 01-1 0V.5A.5.5 0 01.41.008L.5 0h12z"></path>
        </svg>
      );

    if (icon === "corner")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
          <path d="M0 10.308v4.93h3.556v-4.93c0-3.707 3.389-6.723 7.555-6.723H16V0h-4.889C4.984 0 0 4.624 0 10.308z"></path>
        </svg>
      );

    if (icon === "solid")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="2">
          <g fill="none">
            <rect width="16" height="2" x="0" rx="1"></rect>
          </g>
        </svg>
      );

    if (icon === "dashed2")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="2">
          <path
            fill="#A4A8C0"
            d="M3 0a1 1 0 110 2H1a1 1 0 110-2h2zm6 0a1 1 0 110 2H7a1 1 0 110-2h2zm6 0a1 1 0 010 2h-2a1 1 0 010-2h2z"
          ></path>
        </svg>
      );

    if (icon === "dotted")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="2">
          <g>
            <rect width="2" height="2" rx="1"></rect>
            <rect width="2" height="2" x="4" rx="1"></rect>
            <rect width="2" height="2" x="8" rx="1"></rect>
            <rect width="2" height="2" x="12" rx="1"></rect>
          </g>
        </svg>
      );

    if (icon === "border")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
          <path d="M3 0h10a3 3 0 013 3v10a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm0 2a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1V3a1 1 0 00-1-1H3z"></path>
        </svg>
      );

    if (icon === "borderTop")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
          <g fill="none">
            <path
              style={{ fill: "#cccedc" }}
              d="M16 2H0a2 2 0 012-2h12a2 2 0 012 2z"
            ></path>
            <path
              fill="currentColor"
              d="M0 2h2v12h12V2h2v12l-.005.15a2 2 0 01-1.838 1.844L14 16H2a2 2 0 01-1.995-1.85L0 14V2z"
            ></path>
          </g>
        </svg>
      );

    if (icon === "borderBottom")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
          <g fill="none">
            <path
              fill="currentColor"
              d="M0 2h2v12h12V2h2v12l-.005.15a2 2 0 01-1.838 1.844L14 16H2a2 2 0 01-1.995-1.85L0 14V2z"
            ></path>
            <path
              style={{ fill: "#cccedc" }}
              d="M16 14H0a2 2 0 002 2h12a2 2 0 002-2z"
            ></path>
            <path
              fill="currentColor"
              d="M0 14h2V2h12v12h2V2l-.005-.15A2 2 0 0014.157.007L14 0H2A2 2 0 00.005 1.85L0 2v12z"
            ></path>
            <path fill="#cccedc" d="M16 2H0a2 2 0 012-2h12a2 2 0 012 2z"></path>
          </g>
        </svg>
      );

    if (icon === "borderLeft")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
          <g fill="none">
            <path
              style={{ fill: "#cccedc" }}
              d="M2 0v16a2 2 0 01-2-2V2a2 2 0 012-2z"
            ></path>
            <path
              fill="currentColor"
              d="M2 16v-2h12V2H2V0h12l.15.005a2 2 0 011.844 1.838L16 2v12a2 2 0 01-1.85 1.995L14 16H2z"
            ></path>
          </g>
        </svg>
      );

    if (icon === "borderRight")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
          <g fill="none">
            <path
              style={{ fill: "#cccedc" }}
              d="M14 0v16a2 2 0 002-2V2a2 2 0 00-2-2z"
            ></path>
            <path
              fill="currentColor"
              d="M14 16v-2H2V2h12V0H2l-.15.005A2 2 0 00.007 1.843L0 2v12a2 2 0 001.85 1.995L2 16h12z"
            ></path>
          </g>
        </svg>
      );

    if (icon === "undo")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 454.839 454.839">
          <g>
            <path d="M404.908,283.853c0,94.282-76.71,170.986-170.986,170.986h-60.526c-10.03,0-18.158-8.127-18.158-18.157v-6.053 c0-10.031,8.127-18.158,18.158-18.158h60.526c70.917,0,128.618-57.701,128.618-128.618c0-70.917-57.701-128.618-128.618-128.618 H122.255l76.905,76.905c8.26,8.257,8.26,21.699,0,29.956c-8.015,8.009-21.964,7.997-29.961,0L56.137,149.031 c-4.001-4.001-6.206-9.321-6.206-14.981c0-5.656,2.205-10.979,6.206-14.978L169.205,6.002c7.997-8.003,21.958-8.003,29.956,0 c8.26,8.255,8.26,21.699,0,29.953l-76.905,76.911h111.666C328.198,112.866,404.908,189.573,404.908,283.853z" />
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
      );

    if (icon === "redo")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 454.8 454.8">
          <g>
            <path d="M49.9,283.9c0,94.3,76.7,171,171,171h60.5c10,0,18.2-8.1,18.2-18.2v-6.1c0-10-8.1-18.2-18.2-18.2h-60.5 c-70.9,0-128.6-57.7-128.6-128.6S150,155.2,220.9,155.2h111.7l-76.9,76.9c-8.3,8.3-8.3,21.7,0,30c8,8,22,8,30,0L398.7,149 c4-4,6.2-9.3,6.2-15c0-5.7-2.2-11-6.2-15L285.6,6c-8-8-22-8-30,0c-8.3,8.3-8.3,21.7,0,30l76.9,76.9H220.9 C126.6,112.9,49.9,189.6,49.9,283.9z" />
          </g>
        </svg>
      );

    if (icon === "angle-left")
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 6.2 11"
        >
          <path
            fill="#A4A8C0"
            d="M6,9.8c0.3,0.3,0.3,0.7,0,1s-0.7,0.3-1,0L0.2,6c-0.3-0.3-0.3-0.7,0-1L5,0.2c0.3-0.3,0.7-0.3,1,0s0.3,0.7,0,1 L1.7,5.5L6,9.8z"
          />
        </svg>
      );

    if (icon === "settings")
      return (
        <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
          <path
            fill="#A4A8C0"
            d="m272.066 512h-32.133c-25.989 0-47.134-21.144-47.134-47.133v-10.871c-11.049-3.53-21.784-7.986-32.097-13.323l-7.704 7.704c-18.659 18.682-48.548 18.134-66.665-.007l-22.711-22.71c-18.149-18.129-18.671-48.008.006-66.665l7.698-7.698c-5.337-10.313-9.792-21.046-13.323-32.097h-10.87c-25.988 0-47.133-21.144-47.133-47.133v-32.134c0-25.989 21.145-47.133 47.134-47.133h10.87c3.531-11.05 7.986-21.784 13.323-32.097l-7.704-7.703c-18.666-18.646-18.151-48.528.006-66.665l22.713-22.712c18.159-18.184 48.041-18.638 66.664.006l7.697 7.697c10.313-5.336 21.048-9.792 32.097-13.323v-10.87c0-25.989 21.144-47.133 47.134-47.133h32.133c25.989 0 47.133 21.144 47.133 47.133v10.871c11.049 3.53 21.784 7.986 32.097 13.323l7.704-7.704c18.659-18.682 48.548-18.134 66.665.007l22.711 22.71c18.149 18.129 18.671 48.008-.006 66.665l-7.698 7.698c5.337 10.313 9.792 21.046 13.323 32.097h10.87c25.989 0 47.134 21.144 47.134 47.133v32.134c0 25.989-21.145 47.133-47.134 47.133h-10.87c-3.531 11.05-7.986 21.784-13.323 32.097l7.704 7.704c18.666 18.646 18.151 48.528-.006 66.665l-22.713 22.712c-18.159 18.184-48.041 18.638-66.664-.006l-7.697-7.697c-10.313 5.336-21.048 9.792-32.097 13.323v10.871c0 25.987-21.144 47.131-47.134 47.131zm-106.349-102.83c14.327 8.473 29.747 14.874 45.831 19.025 6.624 1.709 11.252 7.683 11.252 14.524v22.148c0 9.447 7.687 17.133 17.134 17.133h32.133c9.447 0 17.134-7.686 17.134-17.133v-22.148c0-6.841 4.628-12.815 11.252-14.524 16.084-4.151 31.504-10.552 45.831-19.025 5.895-3.486 13.4-2.538 18.243 2.305l15.688 15.689c6.764 6.772 17.626 6.615 24.224.007l22.727-22.726c6.582-6.574 6.802-17.438.006-24.225l-15.695-15.695c-4.842-4.842-5.79-12.348-2.305-18.242 8.473-14.326 14.873-29.746 19.024-45.831 1.71-6.624 7.684-11.251 14.524-11.251h22.147c9.447 0 17.134-7.686 17.134-17.133v-32.134c0-9.447-7.687-17.133-17.134-17.133h-22.147c-6.841 0-12.814-4.628-14.524-11.251-4.151-16.085-10.552-31.505-19.024-45.831-3.485-5.894-2.537-13.4 2.305-18.242l15.689-15.689c6.782-6.774 6.605-17.634.006-24.225l-22.725-22.725c-6.587-6.596-17.451-6.789-24.225-.006l-15.694 15.695c-4.842 4.843-12.35 5.791-18.243 2.305-14.327-8.473-29.747-14.874-45.831-19.025-6.624-1.709-11.252-7.683-11.252-14.524v-22.15c0-9.447-7.687-17.133-17.134-17.133h-32.133c-9.447 0-17.134 7.686-17.134 17.133v22.148c0 6.841-4.628 12.815-11.252 14.524-16.084 4.151-31.504 10.552-45.831 19.025-5.896 3.485-13.401 2.537-18.243-2.305l-15.688-15.689c-6.764-6.772-17.627-6.615-24.224-.007l-22.727 22.726c-6.582 6.574-6.802 17.437-.006 24.225l15.695 15.695c4.842 4.842 5.79 12.348 2.305 18.242-8.473 14.326-14.873 29.746-19.024 45.831-1.71 6.624-7.684 11.251-14.524 11.251h-22.148c-9.447.001-17.134 7.687-17.134 17.134v32.134c0 9.447 7.687 17.133 17.134 17.133h22.147c6.841 0 12.814 4.628 14.524 11.251 4.151 16.085 10.552 31.505 19.024 45.831 3.485 5.894 2.537 13.4-2.305 18.242l-15.689 15.689c-6.782 6.774-6.605 17.634-.006 24.225l22.725 22.725c6.587 6.596 17.451 6.789 24.225.006l15.694-15.695c3.568-3.567 10.991-6.594 18.244-2.304z"
          />
          <path
            fill="#A4A8C0"
            d="m256 367.4c-61.427 0-111.4-49.974-111.4-111.4s49.973-111.4 111.4-111.4 111.4 49.974 111.4 111.4-49.973 111.4-111.4 111.4zm0-192.8c-44.885 0-81.4 36.516-81.4 81.4s36.516 81.4 81.4 81.4 81.4-36.516 81.4-81.4-36.515-81.4-81.4-81.4z"
          />
        </svg>
      );

    if (icon === "h1")
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="11"
          viewBox="0 0 19 11"
        >
          <path
            fill="#A4A8C0"
            fillRule="nonzero"
            d="M9 .26a1 1 0 0 1 .25.7v8.81a1 1 0 0 1-.26.7 1 1 0 0 1-1.37 0 1 1 0 0 1-.25-.7V6.06H1.9v3.71a1 1 0 0 1-.26.7.93.93 0 0 1-.7.27.91.91 0 0 1-.68-.27 1 1 0 0 1-.26-.7V1A1 1 0 0 1 .25.26.92.92 0 0 1 .94 0a.94.94 0 0 1 .7.26.94.94 0 0 1 .26.74v3.5h5.42V1a1 1 0 0 1 .25-.7.92.92 0 0 1 .69-.3.92.92 0 0 1 .74.26zM15.36 0a.91.91 0 0 1 .64.25 1 1 0 0 1 .25.71v8.13h1.58c.62 0 .93.253.93.76 0 .533-.3.797-.9.79h-5.07c-.607 0-.913-.263-.92-.79-.007-.527.3-.783.92-.77h1.56V2.25l-1.44.88a.78.78 0 0 1-.37.12A.66.66 0 0 1 12 3a.93.93 0 0 1-.22-.6.75.75 0 0 1 .39-.67L14.5.27c.256-.167.554-.26.86-.27z"
          />
        </svg>
      );

    if (icon === "h2")
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="11"
          viewBox="0 0 19 11"
        >
          <path
            fill="#A4A8C0"
            fillRule="nonzero"
            d="M9 .32a1 1 0 0 1 .25.7v8.81a1 1 0 0 1-.26.7 1 1 0 0 1-1.37 0 1 1 0 0 1-.25-.7V6.12H1.9v3.71a1 1 0 0 1-.26.7.93.93 0 0 1-.7.27.91.91 0 0 1-.68-.27 1 1 0 0 1-.26-.7V1A1 1 0 0 1 .25.32.92.92 0 0 1 .94.06a.94.94 0 0 1 .7.26.94.94 0 0 1 .26.68v3.56h5.42V1a1 1 0 0 1 .25-.7.92.92 0 0 1 .69-.24.92.92 0 0 1 .74.26zm8.24.46a2.61 2.61 0 0 1 .92 2.1 3.88 3.88 0 0 1-.39 1.72 7.61 7.61 0 0 1-1.32 1.79l-2.6 2.76h4c.58 0 .87.257.87.77 0 .533-.3.797-.9.79h-5.7a.82.82 0 0 1-.62-.23.8.8 0 0 1-.22-.58c0-.305.123-.596.34-.81L15 5.42a5.91 5.91 0 0 0 1-1.27A2.52 2.52 0 0 0 16.26 3a1.4 1.4 0 0 0-.41-1.08 1.64 1.64 0 0 0-1.15-.37 3.17 3.17 0 0 0-1.19.23 6 6 0 0 0-1.16.64 1.85 1.85 0 0 1-.3.17.73.73 0 0 1-.3.07.55.55 0 0 1-.44-.24.9.9 0 0 1-.19-.57.86.86 0 0 1 .08-.39 1 1 0 0 1 .26-.31A5.2 5.2 0 0 1 13 .31 5.36 5.36 0 0 1 14.77 0a3.7 3.7 0 0 1 2.47.78z"
          />
        </svg>
      );

    if (icon === "h3")
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="11"
          viewBox="0 0 19 11"
        >
          <path
            fill="#A4A8C0"
            fillRule="nonzero"
            d="M17.24.77a2.52 2.52 0 0 1 .92 2c0 .541-.16 1.07-.46 1.52a2.52 2.52 0 0 1-1.24 1 2.52 2.52 0 0 1 1.46.9c.308.429.48.938.5 1.463v.197a2.65 2.65 0 0 1-1 2.18 4.2 4.2 0 0 1-2.71.81 5.88 5.88 0 0 1-1.87-.3 4.51 4.51 0 0 1-1.53-.84.91.91 0 0 1-.36-.7.87.87 0 0 1 .19-.56.56.56 0 0 1 .44-.23.66.66 0 0 1 .27.05l.33.17a6.48 6.48 0 0 0 1.2.65 3.37 3.37 0 0 0 1.25.23 2.28 2.28 0 0 0 1.47-.4 1.48 1.48 0 0 0 .48-1.21 1.39 1.39 0 0 0-.5-1.18 2.56 2.56 0 0 0-1.55-.38h-.85a.64.64 0 0 1-.53-.23.82.82 0 0 1-.19-.53.81.81 0 0 1 .19-.54.65.65 0 0 1 .53-.23h.6c1.373 0 2.06-.513 2.06-1.54a1.42 1.42 0 0 0-.44-1.11 1.73 1.73 0 0 0-1.2-.39 4.15 4.15 0 0 0-2.34.87l-.36.15a.67.67 0 0 1-.27.05.55.55 0 0 1-.44-.23.86.86 0 0 1-.19-.56.81.81 0 0 1 .08-.38 1.22 1.22 0 0 1 .26-.32A4.82 4.82 0 0 1 13 .31 5.38 5.38 0 0 1 14.76 0a3.77 3.77 0 0 1 2.48.77zM9 .32a1 1 0 0 1 .25.7v8.81a1 1 0 0 1-.26.7 1 1 0 0 1-1.37 0 1 1 0 0 1-.25-.7V6.12H1.9v3.71a1 1 0 0 1-.26.7.93.93 0 0 1-.7.27.91.91 0 0 1-.68-.27 1 1 0 0 1-.26-.7V1A1 1 0 0 1 .25.32.92.92 0 0 1 .94.06a.94.94 0 0 1 .7.26.94.94 0 0 1 .26.68v3.56h5.42V1a1 1 0 0 1 .25-.7.92.92 0 0 1 .69-.24.92.92 0 0 1 .74.26z"
          />
        </svg>
      );

    if (icon === "h4")
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="11"
          viewBox="0 0 20 11"
        >
          <path
            fill="#A4A8C0"
            fillRule="nonzero"
            d="M16.5 0a1 1 0 0 1 .68.25.92.92 0 0 1 .28.605V7.1h.77a1 1 0 0 1 .67.19.69.69 0 0 1 .23.56c0 .5-.3.75-.9.75h-.77v1.18a1 1 0 0 1-.26.72 1 1 0 0 1-1.37 0 1 1 0 0 1-.26-.72V8.6h-3.93a.83.83 0 0 1-.64-.24.8.8 0 0 1-.23-.58A1.16 1.16 0 0 1 11 7.1L15.66.44A1 1 0 0 1 16 .11a1 1 0 0 1 .5-.11zM9 .28a1 1 0 0 1 .25.7v8.8a1 1 0 0 1-.26.7 1 1 0 0 1-1.37 0 1 1 0 0 1-.25-.7v-3.7H1.9v3.7a1 1 0 0 1-.26.7.93.93 0 0 1-.7.27.91.91 0 0 1-.68-.27 1 1 0 0 1-.26-.7V1A1 1 0 0 1 .25.28.92.92 0 0 1 .94 0a.94.94 0 0 1 .7.26.94.94 0 0 1 .26.74v3.52h5.42V1a1 1 0 0 1 .25-.7.92.92 0 0 1 .69-.3.92.92 0 0 1 .74.28zm6.57 2.82l-2.79 4h2.79v-4z"
          />
        </svg>
      );

    if (icon === "h5")
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="11"
          viewBox="0 0 19 11"
        >
          <path
            fill="#A4A8C0"
            fillRule="nonzero"
            d="M17.59.1c.6 0 .9.25.9.75s-.3.75-.9.75h-4v2.82a3.17 3.17 0 0 1 1.88-.54 3.49 3.49 0 0 1 1.68.43 3 3 0 0 1 1.18 1.19c.286.538.43 1.14.42 1.75a3.51 3.51 0 0 1-.47 1.83 3.23 3.23 0 0 1-1.34 1.24 4.29 4.29 0 0 1-2 .44 5.55 5.55 0 0 1-1.82-.31 4.79 4.79 0 0 1-1.52-.83.91.91 0 0 1-.34-.71.87.87 0 0 1 .19-.56.56.56 0 0 1 .44-.23.78.78 0 0 1 .29.05c.109.046.213.103.31.17a5.72 5.72 0 0 0 1.17.66c.385.152.796.23 1.21.23a2.13 2.13 0 0 0 1.52-.5 1.84 1.84 0 0 0 .52-1.41 1.86 1.86 0 0 0-.53-1.4 2 2 0 0 0-1.46-.52c-.34 0-.678.058-1 .17a3.27 3.27 0 0 0-.94.56 1 1 0 0 1-.59.19.76.76 0 0 1-.51-.18.6.6 0 0 1-.21-.48V1a.89.89 0 0 1 .24-.66.92.92 0 0 1 .68-.24h5zM9 .26a1 1 0 0 1 .25.7v8.81a1 1 0 0 1-.26.7 1 1 0 0 1-1.37 0 1 1 0 0 1-.25-.7V6.06H1.9v3.71a1 1 0 0 1-.26.7.93.93 0 0 1-.7.27.91.91 0 0 1-.68-.27 1 1 0 0 1-.26-.7V1A1 1 0 0 1 .25.26.92.92 0 0 1 .94 0a.94.94 0 0 1 .7.26.94.94 0 0 1 .26.74v3.5h5.42V1a1 1 0 0 1 .25-.7.92.92 0 0 1 .69-.3.92.92 0 0 1 .74.26z"
          />
        </svg>
      );

    if (icon === "h6")
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="11"
          viewBox="0 0 19 11"
        >
          <path
            fill="#A4A8C0"
            fillRule="nonzero"
            d="M15.22 0a5.08 5.08 0 0 1 1.72.31 4.48 4.48 0 0 1 1.46.83c.113.088.208.197.28.32a.82.82 0 0 1 .08.38.87.87 0 0 1-.19.56.55.55 0 0 1-.44.23.78.78 0 0 1-.29-.05 2.1 2.1 0 0 1-.33-.17 4 4 0 0 0-2.22-.87 1.94 1.94 0 0 0-1.73 1 5.56 5.56 0 0 0-.66 2.84 2.58 2.58 0 0 1 1-1.07 3 3 0 0 1 1.54-.4 3.28 3.28 0 0 1 1.73.45 3 3 0 0 1 1.15 1.2 3.68 3.68 0 0 1 .41 1.76 3.62 3.62 0 0 1-.46 1.82A3.27 3.27 0 0 1 17 10.4a3.66 3.66 0 0 1-1.82.45 3.74 3.74 0 0 1-3.1-1.36A6.07 6.07 0 0 1 11 5.61a8 8 0 0 1 .51-3A4.25 4.25 0 0 1 13 .67 3.78 3.78 0 0 1 15.22 0zM9 .32a1 1 0 0 1 .25.7v8.81a1 1 0 0 1-.26.7 1 1 0 0 1-1.37 0 1 1 0 0 1-.25-.7V6.12H1.9v3.71a1 1 0 0 1-.26.7.93.93 0 0 1-.7.27.91.91 0 0 1-.68-.27 1 1 0 0 1-.26-.7V1A1 1 0 0 1 .25.32.92.92 0 0 1 .94.06a.94.94 0 0 1 .7.26.94.94 0 0 1 .26.68v3.56h5.42V1a1 1 0 0 1 .25-.7.92.92 0 0 1 .69-.24.92.92 0 0 1 .74.26zm6.08 5.14a1.81 1.81 0 0 0-1.35.54 1.91 1.91 0 0 0-.52 1.22v.17a1.93 1.93 0 0 0 .52 1.4c.359.36.852.552 1.36.53.498.02.98-.176 1.32-.54h-.01a2 2 0 0 0 .5-1.4 2 2 0 0 0-.5-1.4 1.73 1.73 0 0 0-1.32-.52z"
          />
        </svg>
      );

    if (icon === "paragraph")
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="37"
          height="11"
          viewBox="0 0 37 11"
        >
          <path
            fill="#A4A8C0"
            fillRule="nonzero"
            d="M24.38 9.73a.38.38 0 0 1 0 .75h-24a.38.38 0 0 1 0-.75h24zm11.48-3.24a.38.38 0 0 1 0 .75H.38a.38.38 0 0 1 0-.75h35.48zm0-3.24a.38.38 0 0 1 0 .75H.38a.38.38 0 0 1 0-.75h35.48zm0-3.25a.38.38 0 0 1 0 .75H.38a.38.38 0 0 1 0-.75h35.48z"
          />
        </svg>
      );

    if (icon === "layout")
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="29"
          height="27"
          viewBox="0 0 29 27"
          version="1.1"
        >
          <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="collapse">
              <path
                d="M26,0 C27.3144377,0 28.38,1.0655623 28.38,2.38 L28.38,24 C28.38,25.3144377 27.3144377,26.38 26,26.38 L2.38,26.38 C1.0655623,26.38 0,25.3144377 0,24 L0,2.38 C0,1.0655623 1.0655623,0 2.38,0 L26,0 Z M27.6700001,5.66 L0.75,5.66 L0.75,24 C0.75,24.9 1.48,25.63 2.38,25.63 L26,25.63 C26.4391911,25.640781 26.8641389,25.4738206 27.1785298,25.16696 C27.4929207,24.8600994 27.6700001,24.4393234 27.6700001,24 L27.6700001,5.66 L27.6700001,5.66 Z M26,0.75 L2.38,0.75 C1.48,0.75 0.75,1.48 0.75,2.38 L0.75,4.91 L27.6700001,4.91 L27.6700001,2.38 C27.6700001,1.94067658 27.4929207,1.51990065 27.1785298,1.21304005 C26.8641389,0.906179444 26.4391911,0.739219037 26,0.75 Z"
                id="Shape"
                fill="#A4A8C0"
                fillRule="nonzero"
              ></path>
              <line
                x1="4.25022846"
                y1="10.7238214"
                x2="23.503335"
                y2="10.329801"
                id="Line-Copy"
                stroke="#A4A8C0"
                strokeLinecap="square"
                transform="translate(13.750228, 10.223821) rotate(1.000000) translate(-13.750228, -10.223821) "
              ></line>
              <line
                x1="4.25022846"
                y1="14.0482177"
                x2="23.503335"
                y2="13.6541972"
                id="Line-Copy-2"
                stroke="#A4A8C0"
                strokeLinecap="square"
                transform="translate(13.750228, 13.548218) rotate(1.000000) translate(-13.750228, -13.548218) "
              ></line>
              <line
                x1="4.25022846"
                y1="17.3726139"
                x2="23.503335"
                y2="16.9785935"
                id="Line-Copy-3"
                stroke="#A4A8C0"
                strokeLinecap="square"
                transform="translate(13.750228, 16.872614) rotate(1.000000) translate(-13.750228, -16.872614) "
              ></line>
              <line
                x1="4.12655329"
                y1="20.6970102"
                x2="23.3796599"
                y2="20.3029898"
                id="Line-Copy-4"
                stroke="#A4A8C0"
                strokeLinecap="square"
                transform="translate(13.626553, 20.197010) rotate(1.000000) translate(-13.626553, -20.197010) "
              ></line>
            </g>
          </g>
        </svg>
      );

    if (icon === "popup")
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
          <g
            fill="none"
            fillRule="evenodd"
            stroke="#A4A8C0"
            transform="translate(-1)"
          >
            <path
              strokeWidth="1.2"
              d="M7.2 15h11.6a1.2 1.2 0 011.2 1.2v.6a1.2 1.2 0 01-1.2 1.2H7.2A1.2 1.2 0 016 16.8v-.6A1.2 1.2 0 017.2 15zM5.687 6.518l8.821.06M5.679 9h7.41"
            ></path>
            <rect
              width="22.8"
              height="21.877"
              x="1.54"
              y=".658"
              strokeWidth="1.2"
              rx="2.4"
            ></rect>
            <path strokeLinecap="square" d="M19.5 3.5l2 2m0-2l-2 2"></path>
          </g>
        </svg>
      );

    if (icon === "information")
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
        >
          <g>
            <g>
              <path d="M256,0C114.497,0,0,114.507,0,256c0,141.503,114.507,256,256,256c141.503,0,256-114.507,256-256C512,114.497,397.492,0,256,0z M256,472c-119.393,0-216-96.615-216-216c0-119.393,96.615-216,216-216c119.393,0,216,96.615,216,216C472,375.393,375.384,472,256,472z" />
            </g>
          </g>
          <g>
            <g>
              <path d="M256,214.33c-11.046,0-20,8.954-20,20v128.793c0,11.046,8.954,20,20,20s20-8.955,20-20.001V234.33C276,223.284,267.046,214.33,256,214.33z" />
            </g>
          </g>
          <g>
            <g>
              <circle cx="256" cy="162.84" r="27" />
            </g>
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
      );
    if (icon === "template")
      return (
        <svg
          width="24"
          height="24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="3.75"
            y="3.75"
            width="16.5"
            height="16.5"
            rx="1.25"
            stroke="#A4A8C0"
            strokeWidth="1.5"
          />
          <rect
            x="6.6"
            y="12.9"
            width="10.8"
            height="4.5"
            rx="1"
            stroke="#A4A8C0"
            strokeWidth="1.5"
          />
          <path
            d="M6.6 6.6h7.2M6.6 9.3h3.6"
            stroke="#A4A8C0"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="m16.5 5.7 1.8 1.8M18.3 5.7l-1.8 1.8"
            stroke="#A4A8C0"
            strokeLinecap="round"
          />
        </svg>
      );

    if (icon === "administration")
      return (
        <svg
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0"
          y="0"
          viewBox="0 0 512 512"
        >
          <path d="M255.15 468.625H63.787c-11.737 0-21.262-9.526-21.262-21.262V64.638c0-11.737 9.526-21.262 21.262-21.262H255.15c11.758 0 21.262-9.504 21.262-21.262S266.908.85 255.15.85H63.787C28.619.85 0 29.47 0 64.638v382.724c0 35.168 28.619 63.787 63.787 63.787H255.15c11.758 0 21.262-9.504 21.262-21.262 0-11.758-9.504-21.262-21.262-21.262z"></path>
          <path d="M505.664 240.861L376.388 113.286c-8.335-8.25-21.815-8.143-30.065.213s-8.165 21.815.213 30.065l92.385 91.173H191.362c-11.758 0-21.262 9.504-21.262 21.262 0 11.758 9.504 21.263 21.262 21.263h247.559l-92.385 91.173c-8.377 8.25-8.441 21.709-.213 30.065a21.255 21.255 0 0015.139 6.336c5.401 0 10.801-2.041 14.926-6.124l129.276-127.575A21.303 21.303 0 00512 255.998c0-5.696-2.275-11.118-6.336-15.137z"></path>
        </svg>
      );
    else return <div></div>;
  }

  render() {
    return (
      <span
        onClick={this.props.onClick}
        className={`icon ${this.props.className || ""} ${this.props.icon}`}
      >
        {this.getIcon()}
      </span>
    );
  }
}
